<template>
  <div>
    <vs-button @click="openPopup" color="primary" type="border" class="w-full">Generate Aftercare Document</vs-button>
    <vs-popup v-if="popupActivo" :active.sync="popupActivo">
      <div class="p-5">
        <div>
          <h4 class="mb-2 mt-2">Patient Aftercare</h4>
        </div>
        <div class="p-2">
          <p>Confirm the treatment details and generate your patient aftercare.</p>
          <div class="rounded-lg shadow-md p-4 mt-2">
            <div v-for="treatment in treatmentPlans" :key="treatment._id">
              <h5 class="mb-2">{{ treatment.productName }}</h5>
              <p class="mb-4">
                <strong>Area:</strong> {{ treatment.area }}: {{ treatment.amount }} {{ treatment.unit }}
              </p>
            </div>
          </div>
        </div>
        <div class="mt-2 flex justify-end">
          <vs-button color="primary" type="filled" @click="generateAftercare" :disabled="isGenerating">
            <vs-icon v-if="isGenerating" icon="refresh" class="animate-spin"></vs-icon>
            <span v-else>Create Aftercare</span>
          </vs-button>
          <vs-button @click="closePopup" class="p-2 ml-2" color="primary" type="border" :disabled="isGenerating">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>

export default {
  props: {
    treatmentPlans: {
      type: Array,
    },
    aftercareDetails: {
      type: Object,
      default: () => {
        return {
          aftercareDocumentHistory: [],
          needGeneratePDF: false,
        };
      },
    },
  },
  data() {
    return {
      popupActivo: false,
      isGenerating: false,
    };
  },
  beforeDestroy() {
    // Force close the popup if it's still open
    if (this.popupActivo) {
      this.popupActivo = false;
    }
    
    // Manually remove any orphaned vs-popup DOM elements
    const orphanedElements = document.querySelectorAll('.con-vs-popup, .vs-popup--background');
    orphanedElements.forEach(el => {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });
  },
  methods: {
    openPopup() {
      this.popupActivo = true;
    },
    closePopup() {
      this.popupActivo = false;
    },
    async generateAftercare() {
      if (this.isGenerating) return;
      
      this.isGenerating = true;
      this.$vs.loading();
      
      try {
        const res = await this.$store.dispatch('doctor/docEmrgenerateAfterCareEmail', this.$route.query.appointmentId);
        
        const updatedAftercare = {
          ...this.aftercareDetails,
          aftercareDocumentHistory: [
            res.data.data,
            ...(this.aftercareDetails.aftercareDocumentHistory || []),
          ],
          needGeneratePDF: false,
        };
        
        this.$emit('updateAftercareDetails', updatedAftercare);
        
        this.$vs.notify({
          title: 'Success',
          text: 'Aftercare document successfully generated',
          color: 'success',
        });
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to generate the aftercare document. Please try again later.',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
        this.isGenerating = false;
        this.popupActivo = false;
      }
    },
  },
};
</script>
